import React, { useState, useEffect, useRef } from "react";
import {
  Avatar,
  Box,
  Divider,
  IconButton,
  Button,
  FormControl,
  Typography,
  MenuItem,
  InputLabel,
  Drawer,
  TextField,
  Slider,
  Radio,
  RadioGroup,
  FormControlLabel,
  ToggleButtonGroup,
  ToggleButton,
  Autocomplete,
  Dialog,
  DialogContent,
  FormLabel,
  CircularProgress,
} from "@mui/material";
import { styled } from "@mui/material/styles";
// import filter from "../../../assets/Project_Images/Icons/filter.png";
import clsx from "clsx";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import dayjs, { Dayjs } from "dayjs";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import {
  CancelOutlined,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  WestOutlined,
} from "@mui/icons-material";
import { ErrorMessage, Form, Formik, useFormik, useFormikContext } from "formik";
import * as Yup from "yup";
import {
  ApiGetAllocationCriteriaDetails,
  ApiGetQuiz,
  // SearchName,
  applyTasks,
  fetchAllocations,
  fetchTransportBundle,
  getVisitTimes,
} from "../../../apiService/Core/Apicall.tsx";
import { DatePicker } from "@mui/x-date-pickers";
import { useDispatch, useSelector } from "react-redux";
import { hideLoading, showLoading } from "../../../Redux/loadingSlice.tsx";
import Loading from "../../Loader/Loading.tsx";
import { AppDispatch, RootState } from "../../../Redux/Store.tsx";
import { findData, setData } from "../../../Redux/GetTimeSlice.tsx";
import sad from "../../../assets/Project_Images/sad (2).png";
import { data, useNavigate } from "react-router-dom";
import { fetchClientList } from "../../../Redux/clientSlice.tsx";
import { fetchBusinessList } from "../../../Redux/businessSlice.tsx";
import { toast } from "react-toastify";
import BulkAllocation from "./BulkAllocation.tsx";



interface FormValues {
  location: string;
  filterOption: string;
  range: string;
  venue: string;
  venueId: number;
}
function Transport() {
  const [selectedId, setSelectedId] = useState<number | null>(null);
  // const [selectedId, setSelectedId] = useState<number | null>(window.innerWidth <= 576 ? null : 0);
  const [openFilter, setOpenFilter] = useState(false);
  const autocompleteRef = useRef<any>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const [selectedmonth, setSelectedmonth] = useState<Dayjs>(dayjs());
  const [venueList, setVenueList] = useState<
    { venueId: string; venueName: string }[]
  >([]);
  const [filteredVenues, setFilteredVenues] = useState<
    { venueId: string; venueName: string }[]
  >([]);
  const [location, setLocation] = useState<{
    latitude: number;
    longitude: number;
  }>();
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const dispatch = useDispatch();
  const [totalallocation, setAllocation] = useState<any>();
  const [showfilter, setshowfilter] = useState<string>("");
  const [PostalCode, setPostalCode] = useState<string>("");
  const [showkm, setshowkm] = useState<string>("");
  const [OpenDialog, setOpenDialog] = useState<boolean>(false);
  const [OpenBriefDialog, setOpenBriefDialog] = useState<boolean>(false);
  const [isConfirmApply, setisConfirmApply] = useState<boolean>(false);
  const [OpenQuiz, setOpenQuiz] = useState<boolean>(false);
  const [showvenue, setshowvenue] = useState<string>("");
  const loading = useSelector((state: any) => state.loader.isLoading);
  const applyfilters: Record<string, any> = {};
  const [QuizList, setQuizList] = useState<any[]>([])
  const [selectedOptions, setSelectedOptions] = useState<any>([]);
  const [CorrectAnswer, setCorrectAnswer] = useState<number>(0)

  const visittime = useSelector((state: RootState) => state.counter.data);
  const filtervalue = useSelector(
    (state: RootState) => state.counter.filterData
  );
  const { clientList, error } = useSelector((state: RootState) => state.client);
  const { businessList } = useSelector((state: RootState) => state.busines);
  const [selectedClient, setselectedClient] = useState<string>("mmcommon");
  const [position, setposition] = useState<string>("Individual");
  const [selectedBussiness, setselectedBusiness] = useState<number | string>();
  const [allocationCriteria, setAllocationCriteria] = useState<any>();
  const navigate = useNavigate();
  const [hasMore, setHasMore] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const scrollContainerRef = useRef(null);
  const LIMIT = 50;
  const currentOffsetRef = useRef(0);
  const isFirstLoadRef = useRef(true); // ADD THIS at the top with other refs
  const marks = [
    { value: 0, label: "0 km" },
    { value: 50, label: "50 km" },
  ];

  const initialValues: FormValues = {
    location: "",
    filterOption: "myHome",
    range: "10",
    venue: "",
    venueId: 0,
  };

  // const fetchData = async () => {
  //     try {

  //         const response = await getVisitTimes();
  //         console.log('Get Visited Time', response.data);

  //         dispatch(setData(response.data));
  //     } catch (error) {
  //         console.error("Error fetching visit times:", error);
  //     }
  // };

  // useEffect(() => {
  //     fetchData()
  // }, [dispatch])

  const appdispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    appdispatch(fetchClientList());
    appdispatch(fetchBusinessList(selectedClient));
  }, [appdispatch, selectedClient]);

  const validationSchema = Yup.object({
    location: Yup.string().when([], {
      is: () => formik.values.filterOption === "manual",
      then: (schema) => schema.required("Location is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });
  const onSubmit = (values: FormValues) => {
    position === 'Individual' && getallocation();
    setFilteredVenues(venueList);
  };
  const formik = useFormik({
    initialValues,
    validationSchema,
    validateOnChange: true, // Ensures validation only happens on blur or submit
    validateOnBlur: false,
    onSubmit,
  });

  const shouldDisableDate = (
    date: Dayjs,
    activeMonth: any,
    activeYear: any,
    startDay: any,
    endDay: any,
    visitDaysString: string
  ) => {
    // Convert visitDaysInformation to an array
    const allowedDays = visitDaysString?.split(", ")?.map((day) => day?.trim());
    const formattedDate = date.format("YYYY-MM-DD");

    if (allocationCriteria?.holidayDates?.includes(formattedDate)) {
      return true;
    }

    if (
      allocationCriteria?.businessHolidays?.some(
        (holiday: any) => holiday?.date === formattedDate
      )
    ) {
      return true;
    }

    // Get full day name (e.g., "Monday")
    const dayName = date?.format("dddd");

    // Disable if the day is NOT in the allowedDays array
    if (!allowedDays?.includes(dayName)) {
      return true;
    }

    // Disable dates outside the active month and year
    if (date.month() + 1 !== activeMonth || date.year() !== activeYear) {
      return true;
    }

    // Disable dates outside the given range
    if (date.date() < startDay || date.date() > endDay) {
      return true;
    }

    // Hide non-weekend days 
    if (allocationCriteria?.isNeedToHideNonWeekend) {
      const weekendDays = ["Saturday", "Sunday"];
      if (!weekendDays.includes(dayName)) {
        return true; // Disable Monday to Friday
      }
    }
    // Hide weekend days 
    if (allocationCriteria?.isNeedToHideWeekend) {
      const weekendDays = ["Saturday", "Sunday"];
      if (weekendDays.includes(dayName)) {
        return true; // Disable Monday to Friday
      }
    }

    // 6. New Condition ➡️ Block same weekday as lastJobVisitedDate
    if (
      allocationCriteria?.shouldBeDifferentDayFromPreviousMonth &&
      allocationCriteria?.lastJobVisitedDate
    ) {
      const lastVisitedDayName = dayjs(
        allocationCriteria.lastJobVisitedDate
      ).format("dddd"); // Get day name from last visited date
      if (dayName === lastVisitedDayName) {
        return true; // Block this date
      }
    }

    // New Condition ➡️ Block dates if less than minDaysGapBetweenJobs
    if (allocationCriteria?.minDaysGapBetweenJobs) {
      const gapRequired = allocationCriteria.minDaysGapBetweenJobs;

      if (
        allocationCriteria?.currentMonthVisitedDates &&
        allocationCriteria.currentMonthVisitedDates.length > 0
      ) {
        const visitedDates = allocationCriteria.currentMonthVisitedDates;

        for (let visit of visitedDates) {
          const visitDate = dayjs(visit);

          const startBlockedDate = visitDate.subtract(gapRequired, "day");
          const endBlockedDate = visitDate.add(gapRequired, "day");

          if (
            (date.isAfter(startBlockedDate, "day") &&
              date.isBefore(endBlockedDate, "day")) ||
            date.isSame(startBlockedDate, "day") ||
            date.isSame(endBlockedDate, "day") ||
            date.isSame(visitDate, "day") // include exact visit date
          ) {
            return true;
          }
        }
      }

      // 🔹 2. Else fallback to single date
      else if (allocationCriteria?.lastJobVisitedDate) {
        const lastVisitDate = dayjs(allocationCriteria.lastJobVisitedDate);

        const startBlockedDate = lastVisitDate.subtract(gapRequired, "day");
        const endBlockedDate = lastVisitDate.add(gapRequired, "day");

        if (
          (date.isAfter(startBlockedDate, "day") &&
            date.isBefore(endBlockedDate, "day")) ||
          date.isSame(startBlockedDate, "day") ||
          date.isSame(endBlockedDate, "day") ||
          date.isSame(lastVisitDate, "day")
        ) {
          return true;
        }
      }
    }

    // 🔹 Block dates between venueOpenMinus7Days and venueClosePlus3Days
    if (
      allocationCriteria?.venueOpenMinus7Days &&
      allocationCriteria?.venueClosePlus3Days
    ) {
      const date1 = dayjs(allocationCriteria.venueOpenMinus7Days);
      const date2 = dayjs(allocationCriteria.venueClosePlus3Days);

      if (!date1.isValid() || !date2.isValid()) {
        console.log("Invalid date");
        return false;
      }

      const start = date1.isBefore(date2) ? date1 : date2;
      const end = date1.isBefore(date2) ? date2 : date1;

      if (
        (date.isAfter(start, "day") && date.isBefore(end, "day")) ||
        date.isSame(start, "day") ||
        date.isSame(end, "day")
      ) {
        return true;
      }
    }
  };

  const initializeAutocomplete = () => {
    if (!window.google || !window.google.maps || !window.google.maps.places) {
      console.error("Google Places API is not loaded.");
      return;
    }

    if (!inputRef.current) {
      console.warn("Input reference not found, retrying...");
      setTimeout(initializeAutocomplete, 500);
      return;
    }

    if (autocompleteRef.current) {
      autocompleteRef.current = null;
    }

    try {
      autocompleteRef.current = new window.google.maps.places.Autocomplete(
        inputRef.current as HTMLInputElement,
        {
          types: ["geocode"],
          componentRestrictions: { country: "AU" },
        }
      );

      autocompleteRef.current.addListener("place_changed", () => {
        if (!inputRef.current) return;
        const place = autocompleteRef.current.getPlace();
        if (!place || !place.formatted_address) {
          console.warn("No valid address found.");
          return;
        }
        let postalCode = "";
        if (place.address_components) {
          const postalComponent = place.address_components.find((component) =>
            component.types.includes("postal_code")
          );
          postalCode = postalComponent ? postalComponent.long_name : "";
        }

        formik.setFieldValue("location", place.formatted_address);

        setLocation({
          latitude: place.geometry.location.lat(),
          longitude: place.geometry.location.lng(),
        });
        // formik.setFieldValue("postalCode", postalCode);
        setPostalCode(postalCode);

        setTimeout(() => {
          inputRef.current?.blur();
        }, 100);
      });
      inputRef.current.addEventListener("input", () => {
        if (inputRef.current?.value) {
          autocompleteRef.current.setOptions({ types: ["geocode"] });
        }
      });
    } catch (error) {
      console.error("Error initializing autocomplete:", error);
    }
  };

  useEffect(() => {
    if (formik.values.location.length > 0) {
      setTimeout(() => {
        initializeAutocomplete();
      }, 300);
    }
  }, [formik.values.location]);

  // useEffect(() => {
  //   const fetchVenues = async () => {
  //     try {
  //       const data = `?clientEntityId=${selectedBussiness}&offset=0&limit=500`;
  //       const response = await SearchName(data);
  //       if (response.status) {
  //         const venues = response.data.map((venue: any) => ({
  //           venueId: venue.venueId,
  //           venueName: venue.venueName,
  //         }));
  //         setVenueList(venues);
  //         setFilteredVenues(venues);
  //       }
  //     } catch (error) {
  //       console.error("API Error:", error);
  //     }
  //   };
  //   fetchVenues();
  // }, [selectedBussiness]);

  // Filter venues based on user input
  useEffect(() => {
    if (!formik.values.venue.trim()) {
      setFilteredVenues(venueList);
      return;
    }

    const queryLower = formik.values.venue.toLowerCase();
    const filtered = venueList.filter((venue) =>
      venue.venueName.toLowerCase().includes(queryLower)
    );
    // Sort logic
    filtered.sort((a, b) => {
      const aLower = a.venueName.toLowerCase();
      const bLower = b.venueName.toLowerCase();

      if (aLower === queryLower) return -1;
      if (bLower === queryLower) return 1;

      const aStartsWith = aLower.startsWith(queryLower);
      const bStartsWith = bLower.startsWith(queryLower);
      if (aStartsWith && !bStartsWith) return -1;
      if (!aStartsWith && bStartsWith) return 1;

      return aLower.indexOf(queryLower) - bLower.indexOf(queryLower);
    });

    setFilteredVenues(filtered);
  }, [formik.values.venue, venueList]);

  useEffect(() => {
    formik.values.location = "";

    if (formik.values.venue.length > 0) {
      formik.values.filterOption = "";
      formik.values.range = "";
      formik.values.location = "";
    } else {
      formik.values.filterOption = "myHome";
      formik.values.range = "10";
    }
  }, [formik.values.venue]);

  // -----------------------------------------------------get location -----------------------------------------------
  // useEffect(() => {

  //     const getLocation = () => {
  //         if (navigator.geolocation) {
  //             navigator.geolocation.getCurrentPosition(
  //                 (position) => {
  //                     setLocation({
  //                         latitude: position.coords.latitude,
  //                         longitude: position.coords.longitude,
  //                     });
  //                 },
  //                 (error) => {
  //                     alert(error.message);
  //                     formik.setFieldValue("filterOption", "myHome");
  //                 }
  //             );
  //         } else {
  //             // console.log("Geolocation is not supported by this browser.");
  //         }
  //     }
  //     { formik.values.filterOption === 'nearMe' && getLocation()}
  // }, [formik.values.filterOption])

  const handleOpenQuiz = async (clientEntityId:string, venueId:string) => {
    const data = `?clientEntityId=${clientEntityId}&venueId=${venueId}`
    const response = await ApiGetQuiz(data)
    setQuizList(response.data)
    if (response.data.length > 0) {
      setOpenQuiz(true)
    }
    else {
      formik.handleSubmit()
    }

    setSelectedOptions([])
  }


  useEffect(() => {

    const newOptions = QuizList.map((item) => ({
      QuestionId: item.quiz_question_id,
      SelectedAnswer: null,
      answer: item.answer
    }));

    setSelectedOptions(prevOptions => [...prevOptions, ...newOptions]);
  }, [QuizList])

  useEffect(() => {
    const getLocation = () => {
      navigator.permissions
        .query({ name: "geolocation" })
        .then((permissionStatus) => {
          if (permissionStatus.state === "granted") {
            // User already allowed location
            navigator.geolocation.getCurrentPosition((position) => {
              setLocation({
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
              });
            });
          } else if (permissionStatus.state === "prompt") {
            // User hasn't decided yet, ask for permission
            navigator.geolocation.getCurrentPosition(
              (position) => {
                setLocation({
                  latitude: position.coords.latitude,
                  longitude: position.coords.longitude,
                });
              },
              (error) => {
                toast.error(error.message);
                formik.setFieldValue("filterOption", "myHome");
              }
            );
          } else if (permissionStatus.state === "denied") {
            // User denied location before, suggest enabling it
            toast.error(
              "Location access is blocked. Please enable it in your browser settings."
            );
            formik.setFieldValue("filterOption", "myHome");
          }
        });
    };

    if (formik.values.filterOption === "nearMe") {
      getLocation();
    }
  }, [formik.values.filterOption]);

  const handlePrevMonth = () => {
    setSelectedmonth((prev) => prev.subtract(1, "month"));
  };

  const handleNextMonth = () => {
    setSelectedmonth((prev) => prev.add(1, "month"));
  };

  const getallocation = async (currentOffset = 0, append = false) => {
    try {
      setIsLoadingMore(true);
      applyfilters.limit = LIMIT
      applyfilters.offset = currentOffset
      applyfilters.jobMonth = selectedmonth.month() + 1;
      applyfilters.jobYear = selectedmonth.year();
      applyfilters.userId = userData.userId;
      applyfilters.allocationClientGroup = 'TRANSPORT';
      applyfilters.isUseForRunningAllocation = true;

      // const data = `?month=${selectedmonth.month() + 1}&year=${selectedmonth.year()}`

      // setAllocation(await fetchAllocations(applyfilters));
      const response = await fetchAllocations(applyfilters);

      // Append or replace data
      if (append && currentOffset > 0) {
        setAllocation(prev => ({
          ...response,
          data: [...(prev?.data || []), ...(response.data || [])]
        }));
      } else {
        setAllocation(response);
        currentOffsetRef.current = 0;
      }

      // Update offset after successful load
      if (response.data && response.data.length > 0) {
        currentOffsetRef.current = currentOffset + response.data.length;
      }

      // Check if there's more data
      setHasMore(response.data && response.data.length >= LIMIT);
    } catch (error) {
      console.error("Error fetching applied allocations:", error);
    } finally {
      setIsLoadingMore(false);
    }
  };

  useEffect(() => {
    position === 'Individual' && getallocation();
  }, [selectedmonth, position]);

  const fetchAllocationCriteria = async (allocationId: any, clientEntityId: any) => {
    try {
      const data = `?allocationId=${allocationId}&clientEntityId=${clientEntityId}&userId=${userData?.userId}`;
      const response = await ApiGetAllocationCriteriaDetails(data);
      setAllocationCriteria(response.data);
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        String(error);
      console.log(message)
    }

  };

  useEffect(() => {
    if (totalallocation?.data?.length > 0) {
      setSelectedId(window.innerWidth <= 576 ? null : 0);
      dispatch(
        findData(
          totalallocation.data[0].visitTimeInformation?.split(",").map(Number)
        )
      );

      if (isFirstLoadRef.current && position === 'Individual') {
        fetchAllocationCriteria(
          totalallocation.data[0]?.allocationId,
          totalallocation?.data[0]?.venueId?.clientEntityId.clientEntityId
        );
        isFirstLoadRef.current = false; // Set to false after first call
      }
    }
  }, [totalallocation, position]);



  const fetchData = async () => {
    try {
      const response = await getVisitTimes();

      dispatch(setData(response.data));
    } catch (error) {
      console.error("Error fetching visit times:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch]);
  const selectcard = (index: number) => {
    setSelectedId(index);
    dispatch(
      findData(
        totalallocation?.data[index || 0].visitTimeInformation
          .split(",")
          .map(Number)
      )
    );
    // console.log("filteredTime", filtervalue);
    position === 'Individual' && fetchAllocationCriteria(totalallocation.data[index || 0].allocationId, totalallocation?.data[index || 0]?.venueId.clientEntityId.clientEntityId);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 576) {
        setSelectedId(selectedId ? selectedId : 0);
      } else {
        setSelectedId(selectedId ? selectedId : 0);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleDialogOpen = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };


  const handleBriefDialogOpen = () => {
    setOpenBriefDialog(true);
  };
  const handleBriefDialogClose = () => {
    setOpenBriefDialog(false);
  };

  const VisitDateResetter = ({ selectedmonth, selectedId, totalallocation }) => {
    const { setFieldValue } = useFormikContext();

    useEffect(() => {
      if (
        selectedmonth &&
        totalallocation?.data[selectedId]?.jobMonth &&
        selectedmonth.month() + 1 !== totalallocation.data[selectedId].jobMonth
      ) {
        setFieldValue("selectedVisitDate", "");
      }
    }, [selectedmonth, selectedId]);

    return null; // This component only runs the effect
  };


  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string
  ) => {
    if (newAlignment !== null) {
      setposition(newAlignment);
    }
  };


  const handleScroll = (e) => {
    const element = e.target;
    const bottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 100;

    if (bottom && hasMore && !isLoadingMore) {
      position === 'Individual' && getallocation(currentOffsetRef.current, true);
    }
  };

  // Reset pagination when filters change
  useEffect(() => {
    currentOffsetRef.current = 0;
    isFirstLoadRef.current = true
    setHasMore(true);
    setIsLoadingMore(false);
    position === 'Individual' && getallocation(0, false);
  }, [selectedmonth, formik.values.filterOption, selectedClient, formik.values.venue]);

  console.log("Position", position)
  return (
    <Box width="100%" height={{ xs: "calc(100vh - 100px)", md: "100%" }} overflow={'auto'}>
      <Box
        className="justify-content-end align-items-center flex-column-reverse flex-md-row mb-0"
        display={{ xs: selectedId !== null ? "none" : "flex", sm: "flex" }}
      >
        {/* <Box className="col-lg-4 col-md-6 col-sm-12 p-2 p-lg-3 pb-lg-0 mb-0">
          <Box
            className="d-flex custom-bg mx-auto text-center justify-content-between py-1  ps-3 pe-1 align-items-center"
            width="fit-content"
            borderRadius="50px"
          >
            <Typography className="text-light text-center">
              {showfilter
                ? showfilter === "nearMe"
                  ? "Near Me"
                  : showfilter === "myHome"
                    ? "My Home"
                    : PostalCode
                : showvenue}
            </Typography>
            <Divider orientation="vertical" className="mx-3 divider" />
            {showkm && showfilter && (
              <>
                <Typography className="text-light text-center">
                  {showkm}km
                </Typography>
                <Divider orientation="vertical" className="ms-3 me-1 divider" />
              </>
            )}
            <IconButton
              className="text-light"
              onClick={() => setOpenFilter(true)}
            >
              <Box component="img" width="60%" src={filter} alt="filter"></Box>
            </IconButton>
          </Box>
        </Box> */}



        <Box p={{ xs: 0, lg: 3 }} className=" mytask w-100  align-items-center d-flex justfy-content-between align-items-center mx-auto mx-md-0  pt-0 pb-lg-0 mb-0">
          <Box p={{ xs: 0, lg: 0 }} className="col-lg-4 d-flex justify-content-center col-md-6 col-sm-12  pb-lg-0 mb-0">
            <ToggleButtonGroup
              className="w-75 m-0 px-0 mx-auto"
              exclusive
              value={position}
              onChange={handleChange}
            >
              <ToggleButton className="py-2 col-6" value="Individual">
                Individual
              </ToggleButton>
              <ToggleButton className="py-2 col-6" value="Bundle">
                Bundle
              </ToggleButton>

            </ToggleButtonGroup>
          </Box>
          <Box bgcolor={{ xs: "#ADB792", lg: 'transparent' }} className="d-flex  justify-content-end col-lg-8 col-md-6 col-sm-12  align-items-center">
            <Box className="py-2">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent={{ xs: "space-between", lg: 'end' }}
                  className="col-12 ms-auto"
                >
                  {/* Previous Month Button */}
                  <IconButton
                    onClick={handlePrevMonth}
                    className="d-none d-md-block"
                  >
                    <KeyboardArrowLeft />
                  </IconButton>

                  {/* Month & Year Selector */}
                  <DatePicker
                    className="w-100"
                    views={["year", "month"]}
                    value={selectedmonth}
                    onChange={(date) => date && setSelectedmonth(date)}
                    renderInput={(params) => (
                      <TextField {...params} variant="standard" />
                    )}
                    sx={{
                      // "@media (max-width: 600px)": {
                      //   input: { display: "none" }, // Hide input on extra-small screens
                      // },

                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                        maxWidth: "70%",
                      },
                      "& .MuiOutlinedInput-input": {
                        maxWidth: "90%",
                        fontSize: '16px'
                      },
                      "& .MuiIconButton-root": {
                        margin: "0px",
                        padding: "0px",
                        color: "#7C9FB2",
                      },
                      "& .MuiSvgIcon-root": {
                        fontSize: { xs: "32px", md: "20px" },
                      },

                      "& .MuiOutlinedInput-root": {
                        margin: "0px",
                        paddingLeft: "0px",
                        // maxWidth:'190px !important'
                      },
                    }}
                  />

                  <IconButton
                    onClick={handleNextMonth}
                    className="d-none d-md-block"
                  >
                    <KeyboardArrowRight />
                  </IconButton>
                </Box>
              </LocalizationProvider>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        className="d-flex flex-column flex-lg-row"
        minHeight={{ md: "calc(100vh - 133px)" }}
        height={"fit-content"}
        overflow={"auto"}
      >
        {position === "Bundle" ? (
          <Box className="w-100">
            <BulkAllocation date={selectedmonth} isTransport={true} />
          </Box>
        ) : totalallocation?.data?.length > 0 ? (
          <>
            <Box
              className="col-lg-4 col-12 p-3"
              display={{
                xs: selectedId !== null ? "none" : "block",
                sm: "block",
              }}
              height="fit-content"
            >
              {/* ------------------------------------------------------------------------------------- Tasks ------------------------------------------------------------- */}
              <Box
                className="h-100"
                maxHeight="calc(100vh - 50px - 130px)"
                overflow="auto"
                ref={scrollContainerRef}
                onScroll={handleScroll}
              >
                {totalallocation.data.map((card: any, index: number) => (
                  <Box
                    className={clsx("task mb-3", {
                      "bg-alternate": selectedId === index,
                    })}
                    border={selectedId === index ? "" : "1px solid #ccc"}
                    key={index}
                    onClick={() => selectcard(index)}
                  >
                    <Box className="d-flex gap-2 align-items-center">
                      <Avatar
                        src={totalallocation?.data[index]?.venueId?.logoUrl}
                        sx={{
                          height: "40px",
                          width: "42px",
                          img: { objectFit: "contain" },
                        }}
                      >
                        {(!totalallocation?.data[index]?.venueId?.logoUrl &&
                          totalallocation?.data[index]?.venueId?.venueName?.[0]?.toUpperCase()) ||
                          "N"}
                      </Avatar>

                      <Box>
                        <Typography
                          variant="subtitle1"
                          fontWeight="bold"
                          className="m-0 p-0"
                        >
                          {card.venueId?.venueName}{" "}
                          {card?.differentiateKey ? `(${card?.differentiateKey})` : ""}
                        </Typography>
                        <Typography variant="caption" className="task-caption">
                          {card.allocationPriceDisplay ?? "N/A"}
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <Typography variant="body2" className="text-end">
                        {card?.distanceInKm}
                        {card?.distanceInKm ? "km" : ""}
                      </Typography>
                      <Typography
                        variant="caption"
                        className="px-3 py-1 bg-second"
                        borderRadius="8px"
                      >
                        {
                          card.venueId?.clientEntityId?.entityTypeId
                            ?.entityTypeName
                        }
                      </Typography>
                    </Box>
                  </Box>
                ))}
                {isLoadingMore && (
                  <Box className="text-center py-3">
                    <CircularProgress size={24} />
                  </Box>
                )}
              </Box>
            </Box>

            <Box className="col-lg-8 col-12 p-3" overflow={"auto"}>
              {selectedId !== null && totalallocation?.data[selectedId] && (
                <>
                  <Box
                    className="d-flex h-100 flex-md-row flex-column"
                    border={{ xs: "none", sm: "1px solid #a3a3a3" }}
                    borderRadius="10px"
                  >
                    <IconButton
                      className="w-100 justify-content-start d-flex d-md-none"
                      onClick={() => {
                        setSelectedId(null);
                      }}
                    >
                      <WestOutlined fontSize="medium" />
                    </IconButton>
                    <Box className="col-md-6 col-xl-7 col-12 p-3">
                      <Box className="d-flex gap-3">
                        <Box className="d-flex gap-2">
                          {/* <Avatar sx={{ height: '42px', width: '42px' }}>{totalallocation?.data[selectedId].venueId.logoUrl}</Avatar> */}
                          <Avatar
                            src={
                              totalallocation?.data[selectedId]?.venueId?.logoUrl
                            }
                            sx={{
                              height: "40px",
                              width: "42px",
                              img: {
                                objectFit: "contain", // ensures the full image fits inside
                              },
                            }}
                          >
                            {(!totalallocation?.data[selectedId]?.venueId?.logoUrl && totalallocation?.data[selectedId]?.venueId?.venueName?.[0]?.toUpperCase()) || "N"}
                          </Avatar>

                          <Box>
                            <Typography
                              variant="subtitle1"
                              fontWeight="bold"
                              className="m-0 p-0"
                            >
                              {
                                totalallocation.data[selectedId].venueId
                                  ?.venueName
                              } {totalallocation.data[selectedId]?.differentiateKey ? `(${totalallocation.data[selectedId]?.differentiateKey})` : ''}
                            </Typography>
                            <Typography
                              variant="caption"
                              className="px-3 py-1 bg-second"
                              borderRadius="8px"

                            >
                              {
                                totalallocation.data[selectedId].venueId
                                  ?.clientEntityId?.entityTypeId?.entityTypeName
                              }
                            </Typography>
                          </Box>
                        </Box>
                        <Typography variant="subtitle1" className="text-main">
                          {
                            totalallocation.data[selectedId].allocationPriceDisplay ?? "N/A"
                          }
                        </Typography>
                      </Box>
                      <Box className="my-2">
                        <Typography variant="subtitle2" className="text-grey">
                          Address
                        </Typography>
                        <Typography variant="subtitle1" fontWeight="bold">
                          {totalallocation.data[selectedId].venueId?.address} {totalallocation.data[selectedId].venueId?.city} {totalallocation.data[selectedId].venueId?.state} {totalallocation.data[selectedId].venueId?.postalCode}
                        </Typography>
                      </Box>
                      <Box className="my-2">
                        <Typography variant="subtitle2" className="text-grey">
                          PostCode
                        </Typography>
                        <Typography variant="subtitle1" fontWeight="bold">
                          {totalallocation.data[selectedId].venueId?.postalCode}
                        </Typography>
                      </Box>
                      <Box className="my-2">
                        <Typography variant="subtitle2" className="text-grey">
                          Trading Hours
                        </Typography>
                        <Typography variant="subtitle1" fontWeight="bold">
                          {totalallocation.data[selectedId].venueId?.tradingHours}
                        </Typography>
                      </Box>
                      <Box className="my-2">
                        <Typography variant="subtitle2" className="text-grey">
                          Website
                        </Typography>
                        <Typography variant="subtitle1" fontWeight="bold">
                          <a target="__blank" href={totalallocation.data[selectedId].venueId?.websiteURL}>{totalallocation.data[selectedId].venueId?.websiteURL}</a>
                        </Typography>
                      </Box>
                      <Box className="my-2">
                        <Typography variant="subtitle2" className="text-grey">
                          Special Comments
                        </Typography>
                        <Typography variant="subtitle1" fontWeight="bold">
                          {totalallocation.data[selectedId].specialComment}
                        </Typography>
                      </Box>
                      <Box className="my-2">
                        <Button
                          fullWidth
                          variant="outlined"
                          className="button-secondary-outlined mt-3"
                          onClick={handleDialogOpen}
                        >
                          Read Brief
                        </Button>
                      </Box>
                    </Box>
                    {/* {window.innerWidth > 767 && ( */}
                    <Divider
                      orientation="vertical"
                      sx={{
                        display: { xs: "none", sm: "block" },
                        borderColor: "#a3a3a3",
                      }}
                    />
                    {/* )} */}
                    <Formik
                      className="w-100 col-md-6 col-xl-5"
                      initialValues={{
                        allocationId: null,
                        selectedVisitDate: "",
                        selectedVisitTime: "",
                        createdBy: userData.userId,
                      }}
                      validationSchema={Yup.object({
                        selectedVisitDate: Yup.string().required("Select a Date"),
                        selectedVisitTime: Yup.string().required("Select a TIme"),
                      })}
                      onSubmit={async (values) => {

                        const formattedValues = {
                          ...values,
                          allocationId:
                            totalallocation.data[selectedId].allocationId,
                          selectedVisitDate: values.selectedVisitDate
                            ? dayjs(values.selectedVisitDate).format("YYYY-MM-DD")
                            : "",
                        };

                        // console.log("Login Form Submitted:", formattedValues);

                        try {
                          const response = await applyTasks(formattedValues);

                          toast.success('You have successfully applied. Hold tight to find out if you are successful.');
                          navigate("/dashboard/mytasks");
                        } catch (error: any) {
                          toast.error(error?.message)
                        } finally {
                        }
                      }}
                    >
                      {(formik) => {
                        const handleApplyTaskClick = async () => {
                          formik.setTouched({
                            selectedVisitDate: true,
                            selectedVisitTime: true,
                          });

                          const errors = await formik.validateForm();

                          if (Object.keys(errors).length > 0) {
                            return;
                          }

                          handleBriefDialogOpen();
                        };

                        return (
                          <Form className="w-100">
                            <VisitDateResetter
                              selectedmonth={selectedmonth}
                              selectedId={selectedId}
                              totalallocation={totalallocation}
                            />
                            <Box className=" w-100 d-flex flex-column col-12 p-3">
                              <Box className="flex-grow-1">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                  <StaticDatePicker
                                    key={selectedmonth.toString()}
                                    value={
                                      formik.values.selectedVisitDate
                                        ? dayjs(formik.values.selectedVisitDate)
                                        : null
                                    }
                                    onChange={(newValue) => {
                                      formik.setFieldValue(
                                        "selectedVisitDate",
                                        newValue
                                          ? newValue.format("YYYY-MM-DD")
                                          : ""
                                      );
                                    }}
                                    referenceDate={
                                      selectedmonth
                                        ? dayjs(selectedmonth, "YYYY-MM")
                                        : dayjs()
                                    }
                                    // minDate={dayjs(
                                    //   selectedmonth,
                                    //   "YYYY-MM"
                                    // ).startOf("month")}
                                    minDate={dayjs()}

                                    maxDate={dayjs(selectedmonth, "YYYY-MM").endOf(
                                      "month"
                                    )}
                                    shouldDisableDate={(date) =>

                                      // totalallocation.data[selectedId]?.venueId?.locationType === 'region'
                                      //   ?
                                      //   shouldDisableDate(
                                      //     date,
                                      //     totalallocation.data[selectedId].jobMonth,
                                      //     totalallocation.data[selectedId].jobYear,
                                      //     allocationCriteria?.regionMinDate,
                                      //     allocationCriteria?.regionMaxDate,
                                      //     allocationCriteria?.regionVisitDaysInformation
                                      //   )
                                      //   :
                                      shouldDisableDate(
                                        date,
                                        totalallocation.data[selectedId].jobMonth,
                                        totalallocation.data[selectedId].jobYear,
                                        totalallocation.data[selectedId]?.minDate,
                                        totalallocation.data[selectedId]?.maxDate,
                                        totalallocation.data[selectedId]?.visitDaysInformation
                                        // allocationCriteria?.minDate,
                                        // allocationCriteria?.maxDate,
                                        // allocationCriteria?.visitDaysInformation
                                      )
                                    }
                                    sx={{
                                      "& .MuiPickersCalendarHeader-switchViewButton":
                                      {
                                        // display: "none",
                                      },
                                      "& .MuiPickersArrowSwitcher-root": {
                                        // display: "none",
                                      },
                                      "& .MuiPickersCalendarHeader-labelContainer":
                                      {
                                        pointerEvents: "none",
                                      },
                                    }}
                                  />
                                </LocalizationProvider>
                                <FormControl fullWidth>
                                  <InputLabel
                                    id="demo-simple-select-label"
                                    shrink={false}
                                  >
                                    {" "}
                                    <span>
                                      Visiting Time{" "}
                                      <sup>
                                        <i className="fa-solid fa-star-of-life star"></i>
                                      </sup>
                                    </span>
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-label"
                                    aria-placeholder="Select the Time"
                                    value={formik.values.selectedVisitTime}
                                    onChange={(e) =>
                                      formik.setFieldValue(
                                        "selectedVisitTime",
                                        e.target.value
                                      )
                                    }
                                    MenuProps={{
                                      disablePortal: false, // Ensures dropdown is rendered inside the parent DOM
                                    }}
                                  >
                                    {filtervalue?.map((option, index) => (
                                      <MenuItem
                                        key={index}
                                        value={option.visitTimeId}
                                      >
                                        {option.visitTimeInformation}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                                <ErrorMessage
                                  name="selectedVisitTime"
                                  component="div"
                                  className="error"
                                />
                              </Box>
                              {/* <p>{ totalallocation?.data[selectedId]?.venueId?.clientEntityId?.clientEntityId}</p> */}
                              <Button
                                // type={totalallocation?.data[selectedId]?.venueId?.clientEntityId?.quizBrief ? "button" }
                                className="button-primary mt-4"
                                fullWidth
                                onClick={async () => {
                                  if (allocationCriteria?.isQuizRequired) {
                                    await handleOpenQuiz(totalallocation?.data[selectedId]?.venueId?.clientEntityId?.clientEntityId,totalallocation?.data[selectedId]?.venueId?.venueId);
                                  }
                                  else {
                                    handleApplyTaskClick()
                                  }
                                }}
                              >
                                Apply Task
                              </Button>
                            </Box>
                            <Dialog open={OpenQuiz} onClose={() => { setOpenQuiz(false) }}>
                              <DialogContent>
                                {QuizList && QuizList.map((item, index) => (
                                  <Box className='mb-3'>
                                    <Box className="d-flex mb-0" gap={1}>
                                      <span className="fw-bold">Q{index + 1}.</span>
                                      <div className="mb-0 quiz" key={index} dangerouslySetInnerHTML={{ __html: item.question_text }} />
                                    </Box>
                                    <FormControl>
                                      <RadioGroup
                                        aria-labelledby="demo-radio-buttons-group-label"
                                        value={selectedOptions[index]?.SelectedAnswer}
                                        name="radio-buttons-group"
                                        onChange={(e) => {
                                          const updatedOptions = [...selectedOptions];
                                          updatedOptions[index] = {
                                            ...updatedOptions[index],
                                            SelectedAnswer: parseInt(e.target.value)
                                          };
                                          setSelectedOptions(updatedOptions);
                                        }}

                                      >
                                        {JSON.parse(item.options).map((option, index) => (
                                          <FormControlLabel value={parseInt(option.option_id)} control={<Radio />} label={option.option_label} />
                                        ))}
                                      </RadioGroup>
                                    </FormControl>
                                  </Box>
                                ))}
                                <Button
                                  className="button-primary px-4 py-2 ml-auto"
                                  onClick={() => {
                                    let correct = 0;
                                    selectedOptions.map(item => {
                                      if (item.SelectedAnswer === item.answer) {
                                        correct++;
                                      }
                                    })
                                    handleOpenQuiz(totalallocation?.data[selectedId]?.venueId?.clientEntityId?.clientEntityId,totalallocation?.data[selectedId]?.venueId?.venueId)
                                    if (correct === selectedOptions.length) {
                                      handleApplyTaskClick()
                                      // formik.handleSubmit()
                                    }
                                    else {
                                      toast.error(`${correct}/${selectedOptions.length} Are Corrected`)
                                    }
                                  }}
                                >
                                  Submit
                                </Button>
                              </DialogContent>
                            </Dialog>
                            <Dialog open={OpenBriefDialog}>
                              <DialogContent>
                                {selectedId !== null && totalallocation?.data[selectedId] ? (
                                  <>
                                    <IconButton
                                      className="ms-auto d-block"
                                      onClick={() => {
                                        handleBriefDialogClose();
                                      }}
                                    >
                                      <CancelOutlined className="fd-2" />
                                    </IconButton>
                                    <Box
                                      overflow="auto"
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          totalallocation.data[selectedId].venueId
                                            ?.venueDescription || "",
                                      }}
                                    />
                                    <div className="d-flex my-2">
                                      <label className="d-flex align-items-center justify-content-center gap-2">
                                        <input
                                          type="checkbox"
                                          onChange={(e) => { setisConfirmApply(e.target.checked) }}
                                        />
                                        <span>Read & understood</span>
                                      </label>
                                    </div>
                                    <Button
                                      disabled={!isConfirmApply}
                                      className="button-primary mx-auto py-2 px-4 d-block"
                                      onClick={() => {
                                        formik.handleSubmit()
                                      }}
                                      sx={{
                                        "&.Mui-disabled": {
                                          backgroundColor: "#ccc !important",
                                          color: "#666 !important",
                                          cursor: "not-allowed",
                                        },
                                      }}
                                    >
                                      Apply
                                    </Button>
                                  </>
                                ) : (
                                  <Typography variant="subtitle1">No Data Found</Typography>
                                )}
                              </DialogContent>
                            </Dialog>
                          </Form>
                        )
                      }}
                    </Formik>
                  </Box>
                </>
              )}
            </Box>
          </>
        ) : (
          <Box
            className="w-100 d-flex align-items-start pt-5 justify-content-center"
            height={"calc(100vh - 133px)"}
          >
            <Box>
              <Typography
                className="text-center mt-3 fw-bold text-main"
                variant="h4"
              >
                Looks like this one was snapped up quickly! <br /> Stay on standby—it
                may pop back up.
              </Typography>
            </Box>
          </Box>
        )
        }
      </Box >


      {loading && <Loading />}
      {/* <Drawer
        anchor="right"
        className="w-100 "
        open={openFilter}
        onClose={() => setOpenFilter(false)}
      >
        <form onSubmit={formik.handleSubmit}>
          <Box
            className="d-flex flex-column w-100 px-4 py-3"
            height="100vh"
            bgcolor="white"
          >
            <Box className="flex-grow-1">
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                sx={{ mb: 2 }}
              >
                <Typography variant="h5" className="fw-bold">
                  Filters
                </Typography>
                <IconButton onClick={() => setOpenFilter(false)}>
                  <CancelOutlined />
                </IconButton>
              </Box>

              <Divider
                sx={{
                  my: 2,
                  borderColor: "#00000033",
                  border: "1px solid #00000033",
                  width: "100%",
                }}
              />

              <Typography
                variant="body1"
                className="form-caption"
                sx={{ mb: 1 }}
              >
                Select Any One from below to begin with:
              </Typography>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
           
                {...formik.getFieldProps("filterOption")}
              >
                <FormControlLabel
                  value="myHome"
                  control={<BpRadio />}
                  label="My Home"
                />
                <FormControlLabel
                  value="nearMe"
                  control={<BpRadio />}
                  label="Near Me"
                />
                <FormControlLabel
                  value="manual"
                  control={<BpRadio />}
                  label="Manual"
                />
              </RadioGroup>
              {formik.values.filterOption === "manual" && (
                <FormControl fullWidth sx={{ mt: 2 }}>
                  <Typography variant="body1" className="form-caption" mb={1}>
                    Location <sup style={{ color: "red" }}>*</sup>
                  </Typography>
                  <TextField
                    placeholder="Enter location"
                    name="location"
                    inputRef={inputRef}
                    value={formik.values.location}
                    onChange={(e) => {
                      formik.setFieldValue("location", e.target.value);
                    }}
                    error={
                      formik.touched.location && Boolean(formik.errors.location)
                    }
                    helperText={
                      formik.touched.location && formik.errors.location
                    }
                    autoComplete="off"
                    sx={{
                      position: "relative",
                      zIndex: 1000,
                      backgroundColor: "white",
                    }}
                  />
                </FormControl>
              )}

              <Typography variant="body1" className="form-caption" mt={3}>
                Select Range:
              </Typography>
              <Box className="w-100 d-flex align-items-center justify-content-center">
                <CustomSlider
            
                  min={0}
                  max={50}
                  step={1}
                  marks={marks}
                  valueLabelDisplay="on"
                  valueLabelFormat={(value) => `${value} km`}
                  {...formik.getFieldProps("range")}
                />
              </Box>

             
              <Box display="flex" alignItems="center" width="100%" my={2}>
                <Box flex={1} height="1px" bgcolor="#00000033" />

                <Typography variant="body1" mx={2} color="gray">
                  or
                </Typography>

                <Box flex={1} height="1px" bgcolor="#00000033" />
              </Box>

              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label" shrink={false}>
                  {" "}
                  <span>
                    Select Client{" "}
                    <sup>
                      <i className="fa-solid fa-star-of-life star"></i>
                    </sup>
                  </span>
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  aria-placeholder="Select the Time"
                  value={selectedClient}
                  onChange={(e) => {
                    console.log(e.target.value);
                    setselectedClient(e.target.value);
                    setselectedBusiness('');
                    formik.setFieldValue("venue", '');
                    formik.setFieldValue("venueId", '');
                  }}
                  MenuProps={{
                    disablePortal: false, 
                  }}
                >
                  {clientList?.map((option, index) => (
                    <MenuItem key={index} value={option?.clientGroupName}>
                      {option?.clientGroupName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label" shrink={false}>
                  {" "}
                  <span>
                    Select Business{" "}
                    <sup>
                      <i className="fa-solid fa-star-of-life star"></i>
                    </sup>
                  </span>
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  aria-placeholder="Select the Time"
                  value={selectedBussiness}
                  onChange={(e) => {
                    setselectedBusiness(e.target.value);
                    formik.setFieldValue("venue", '');
                    formik.setFieldValue("venueId", '');
                  }}
                  MenuProps={{
                    disablePortal: false,
                  }}
                >
                  {businessList?.map(
                    (option, index) =>
                      option?.entityName?.length > 0 && (
                        <MenuItem key={index} value={option?.clientEntityId}>
                          {option?.entityName}
                        </MenuItem>
                      )
                  )}
                </Select>
              </FormControl>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label" shrink={false}>
                  {" "}
                  <span>
                    Select Venue{" "}
                    <sup>
                      <i className="fa-solid fa-star-of-life star"></i>
                    </sup>
                  </span>
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  aria-placeholder="Select the Time"
                  value={formik.values.venueId}
                  onChange={(e) => {
                    const selectedVenueId = e.target.value;
                    const selectedVenue = filteredVenues.find(venue => venue.venueId === selectedVenueId);

                    formik.setFieldValue("venueId", selectedVenueId);
                    formik.setFieldValue("venue", selectedVenue?.venueName || "");
                  }}
                  MenuProps={{
                    disablePortal: false,
                  }}
                >
                  {filteredVenues?.map(
                    (option, index) =>
                    (
                      <MenuItem key={index} value={option?.venueId}>
                        {option?.venueName}
                      </MenuItem>
                    )
                  )}
                </Select>
              </FormControl>
            </Box>
            <Button
              variant="contained"
              className="button-primary mt-5"
              fullWidth
              type="submit"
            >
              Apply Filters
            </Button>
          </Box>
        </form>
      </Drawer> */}
      <Dialog open={OpenDialog}>
        <DialogContent>
          {selectedId !== null && totalallocation?.data[selectedId] ? (
            <>
              <IconButton
                className="ms-auto d-block"
                onClick={() => {
                  handleDialogClose();
                }}
              >
                <CancelOutlined className="fd-2" />
              </IconButton>
              <Box
                overflow="auto"
                dangerouslySetInnerHTML={{
                  __html:
                    totalallocation.data[selectedId].venueId
                      ?.venueDescription || "",
                }}
              />
              <Button
                className="button-primary mx-auto py-2 px-4 d-block"
                onClick={() => {
                  handleDialogClose();
                }}
              >
                Continue
              </Button>
            </>
          ) : (
            <Typography variant="subtitle1">No Data Found</Typography>
          )}
        </DialogContent>
      </Dialog>

    </Box >
  );
}

export default Transport;
